import { LoaderCircleIcon } from 'lucide-react'
import { MotionConfig } from 'motion/react'
import { Outlet } from 'react-router'

import Toolbar from 'apps/components/toolbar/Toolbar'
import { Banner } from 'slab'

import { EditingAllowancesProvider } from './EditingAllowancesProvider'
import { EmbeddedOnboardingProvider } from './EmbeddedOnboardingProvider'
import { EmployerMenu } from './EmployerMenu'
import { EmployerProvider } from './EmployerProvider'
import { type FeatureFlags, FlagProvider } from './FlagProvider'
import { PrefillProvider } from './PrefillProvider'

interface OnboardingLayoutProps {
  employerId: string | null
  featureFlags?: FeatureFlags
  embeddedOnboardingBearer?: string | null
  editingAllowances?: boolean
}

export function OnboardingLayout ({ employerId, featureFlags = {}, embeddedOnboardingBearer, editingAllowances = false }: OnboardingLayoutProps) {
  function renderContent ({
    loading,
    error,
  }: {
    loading: boolean;
    error: Error | null;
  }) {
    if (loading) {
      return (
        <div className='flex grow items-center justify-center'>
          <LoaderCircleIcon size={24} className='animate-spin text-gray-500' />
        </div>
      )
    }

    if (error) {
      return (
        <div className='mt-20 w-full max-w-[45rem] mx-auto'>
          <Banner type='critical' title='Error loading employer'>
            {error.message}
          </Banner>
        </div>
      )
    }

    return <Outlet />
  }
  return (
    <FlagProvider flags={featureFlags}>
      <PrefillProvider>
        <EmbeddedOnboardingProvider serverToken={embeddedOnboardingBearer}>
          <EditingAllowancesProvider editingAllowances={editingAllowances}>
            <EmployerProvider employerId={employerId}>
              {({ loading, error }) => (
                <div className='min-h-svh flex flex-col items-stretch isolate bg-gradient-to-t from-thatch-100 to-gray-50 bg-fixed'>
                  <Toolbar trailingComponent={<EmployerMenu />} />
                  <div className='flex flex-col grow px-4 xs:px-6 pt-6 xs:pt-10 pb-4 xs:pb-6'>
                    <MotionConfig transition={{ duration: 0.3 }}>
                      {renderContent({ loading, error })}
                    </MotionConfig>
                  </div>
                </div>
              )}
            </EmployerProvider>
          </EditingAllowancesProvider>
        </EmbeddedOnboardingProvider>
      </PrefillProvider>
    </FlagProvider>
  )
}
